import { ErrorTypes } from '@wix/form-validator';
import { DerivedErrorTypes } from '../../field-error/error-types';
export const OTHER_ID = 'Other';
export const getOtherValue = (value, addOtherLabel) => {
  const addedSymbolsLength = 2; // we add ': ' to other value
  const otherLabelLength = addOtherLabel ? addOtherLabel.length + addedSymbolsLength : 0;
  const otherItem = value.find(item => item.startsWith(`${addOtherLabel}: `)) || '';
  return otherItem.slice(otherLabelLength);
};
export const getTagsError = (validation, error) => {
  var _validation$array, _validation$array2;
  const isMinMaxItemsError = (error == null ? void 0 : error.errorType) === ErrorTypes.MIN_ITEMS_ERROR || (error == null ? void 0 : error.errorType) === ErrorTypes.MAX_ITEMS_ERROR;
  if (!error || !isMinMaxItemsError) {
    return error;
  }
  const minItems = validation == null || (_validation$array = validation.array) == null ? void 0 : _validation$array.minItems;
  const maxItems = validation == null || (_validation$array2 = validation.array) == null ? void 0 : _validation$array2.maxItems;
  const isMinMaxItems = minItems && maxItems;
  if (isMinMaxItems && minItems === maxItems) {
    return {
      ...error,
      errorType: DerivedErrorTypes.EXACT_ITEMS_NUMBER_ERROR,
      errorMessage: `must choose ${minItems} options`
    };
  }
  return error;
};
//# sourceMappingURL=tags-field-utils.js.map